
export class DateRange {
  // tslint:disable-next-line:variable-name
  private _from: Date;
  // tslint:disable-next-line:variable-name
  private _to: Date;
  constructor(from: Date, to: Date) {
    // check if from is greater than to
    if (from > to) {
      throw new Error('from is greater than to');
    }
    this._from = from;
    this._to = to;
  }

  get from(): Date {
    return this._from;
  }

  get to(): Date {
    return this._to;
  }

  public isDateInRange(date: Date): boolean {
    // check limits are not null
    if (this._from === null || this._to === null) {
      return true;
    }
    // check if date is in range
    return date >= this._from && date <= this._to;
  }
}
